import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { selfcreditService } from '../self-credit.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { CreditModalComponent } from '../../requests/credit-modal/credit-modal.component';

interface PublicProfileDto {
  id: number;
  email: string | null;
  webPage: string | null;
  documentType: string | null;
  documentNumber: string | null;
  avatar: string | null;
  color: string | null;
  frontPage: string | null;
  publicName: string | null;
  contactMobile: string | null;
  address: string | null;
}

@Component({
  selector: 'app-profile-public-cover',
  templateUrl: './profile-public-cover.component.html',
  styleUrls: ['./profile-public-cover.component.scss']
})
export class ProfilePublicCoverComponent implements OnInit, OnChanges {
  @Input() userId!: number | string | null;
  @Input() isSimulaCredito!: boolean | null;

  loaded = false;
  isDefault = false;

  // datos
  publicName: string | null = null;
  email: string | null = null;
  webPage: string | null = null;
  documentType: string | null = null;
  documentNumber: string | null = null;
  contactMobile: string | null = null;
  address: string | null = null;

  avatarUrl: string | null = null;
  frontPageUrl: string | null = null;
  color: string | null = null;
  accentColor = '#171d35'; // color del botón (y enlaces)

  // flags
  get hasPublicName() { return this.hasValue(this.publicName); }
  get hasEmail() { return this.hasValue(this.email); }
  get hasPhone() { return this.hasValue(this.contactMobile); }
  get hasAddress() { return this.hasValue(this.address); }
  get hasDocument() { return this.hasValue(this.documentType) && this.hasValue(this.documentNumber); }
  get hasWebPage() { return this.hasValue(this.webPage); }

  // defaults
  defaultColor = '#171d35';
  fallbackAvatar = 'assets/images/logoBankaSoloB.png';
  defaultTitle = 'Bakna';

  // modal crédito
  modalAbierto = false;

  constructor(private users: selfcreditService, private dialog: MatDialog) {}

  ngOnInit(): void { this.load(); }
  ngOnChanges(ch: SimpleChanges): void {
    if (ch['userId'] && !ch['userId'].firstChange) this.load();
  }

  private load(): void {
    this.loaded = false;
    this.isDefault = false;

    const id = this.resolveId(this.userId);
    if (!id) { this.applyDefault(); this.loaded = true; return; }

    this.users.getUserPublic?.(id).subscribe({
      next: (res: PublicProfileDto | null) => {
        if (!res) this.applyDefault();
        else this.hydrate(res);
        this.loaded = true;
      },
      error: () => { this.applyDefault(); this.loaded = true; }
    });
  }

  private hydrate(p: PublicProfileDto): void {
    this.publicName    = this.clean(p.publicName);
    this.email         = this.clean(p.email);
    this.webPage       = this.clean(p.webPage);
    this.documentType  = this.clean(p.documentType);
    this.documentNumber= this.clean(p.documentNumber);
    this.contactMobile = this.clean(p.contactMobile);
    this.address       = this.clean(p.address);
    this.color         = this.clean(p.color) || this.defaultColor;

    this.avatarUrl     = this.toUrl(this.clean(p.avatar));
    this.frontPageUrl  = this.toUrl(this.clean(p.frontPage));

    // color del botón / enlaces
    this.accentColor   = this.isColor(this.color) ? this.color! : '#171d35';
  }

  private applyDefault(): void {
    this.isDefault = false;
    this.webPage = "https://www.bakna.co";
    this.publicName = null; this.email = "admin@bakna.co"; this.documentType = null;
    this.documentNumber = null; this.contactMobile = "+57 (304) 44 19 868"; this.address = null;
    this.color = this.defaultColor;
    this.avatarUrl = null; this.frontPageUrl = null;
    this.accentColor = '#171d35';
  }

  openCreditDialog(): void {
    this.dialog.open(CreditModalComponent, {
      width: '560px',
      maxWidth: '95vw',
      data: true,
      autoFocus: false
    });
  }

  /* helpers */
  private resolveId(id: number | string | null | undefined): number | null {
    if (id === null || id === undefined) return null;
    const n = Number(id); return Number.isFinite(n) && n > 0 ? n : null;
  }
  private hasValue(v: string | null | undefined): boolean {
    return typeof v === 'string' && v.trim().length > 0;
  }
  private clean(v: string | null): string | null {
    if (!v) return null;
    const s = String(v).trim();
    return s.length ? s : null;
  }
  private isColor(v: string | null): boolean {
    return !!v && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v);
  }
  private toUrl(relative: string | null): string | null {
    if (!relative) return null;
    return `${environment.urlDocumentos}${relative}`;
  }
}